// extracted by mini-css-extract-plugin
export default {"row":"MicropilesCompressionSummary_row__pC95H","table":"MicropilesCompressionSummary_table__Z1hfT","min120":"MicropilesCompressionSummary_min120__Tjf0x"};